import { GlobalOutlined, MailOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Card, Col, Form, Input, Row, Typography } from 'antd'
import * as qs from 'qs'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { apiCancelRegistration } from '~/api/adminApi'
import { getRegistration } from '~/api/genericApi'
import { showErrors } from '~/utils/helpers'
import CourseRegistrationLayout from './CourseRegistrationLayout'
import { useCountryQuery, useCourseQuery } from './query'
import './styles.scss'

const { Title } = Typography

const CancelRegistrationForm = () => {
  const { token } = useParams()
  const cancelRegistrationMutation = useMutation({
    mutationFn: apiCancelRegistration,
    onError: showErrors
  })

  const { data, isError: isLoadCourseError } = useCourseQuery(token)
  const { data: countries } = useCountryQuery()
  const course = data?.data

  const { registration_id } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true
  })
  const registrationQuery = useQuery({
    queryFn: () => getRegistration(registration_id),
    onError: showErrors
  })

  const registration = registrationQuery.data

  if (isLoadCourseError) {
    return (
      <div className='signup-form'>
        <Card
          variant='outlined'
          style={{ maxWidth: 350, margin: '40px auto auto' }}
        >
          <Title level={3} style={{ margin: 'auto' }}>
            This event is not available
          </Title>
        </Card>
      </div>
    )
  }

  if (
    cancelRegistrationMutation.isSuccess ||
    registration?.cancelled_at != null
  ) {
    return (
      <div className='signup-form'>
        <Title
          className='course-name'
          level={3}
          style={{ marginBottom: 40, marginTop: 40 }}
        >
          {course?.name}
        </Title>
        <Card variant='outlined' style={{ maxWidth: 450, margin: 'auto' }}>
          <Title level={3}>Successful cancellation</Title>
          <Typography.Paragraph>
            You have successfully cancelled your registration.
          </Typography.Paragraph>
        </Card>
      </div>
    )
  }

  if (course == null || registration == null || countries == null) {
    return null
  }

  return (
    <CourseRegistrationLayout course={course}>
      <div style={{ textAlign: 'center' }}>
        <Title level={2}>Registration Details</Title>
      </div>

      <Form
        name='normal_register'
        className='register-form'
        layout='vertical'
        initialValues={{
          ...registration.data,
          country_name: countries.find(
            (i) => i.code === registration.country_code
          )?.name
        }}
      >
        <Row gutter={10}>
          <Col md={12} xs={24}>
            <Form.Item label='First Name' name='first_name'>
              <Input prefix={<UserOutlined />} readOnly />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item name='last_name' label='Last Name'>
              <Input prefix={<UserOutlined />} readOnly />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item name='email' label='Email'>
              <Input prefix={<MailOutlined />} readOnly />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item name='country_name' label='Country'>
              <Input prefix={<GlobalOutlined />} readOnly />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item name='join_type' label='Join as'>
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item name='institution' label='Institution'>
              <Input readOnly />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            className='register-form-button'
            loading={cancelRegistrationMutation.isPending}
            onClick={() => cancelRegistrationMutation.mutate(registration_id)}
          >
            Cancel my registration
          </Button>
        </Form.Item>
      </Form>
    </CourseRegistrationLayout>
  )
}

CancelRegistrationForm.propTypes = {}

export default CancelRegistrationForm
